import * as types from './mutation-types'

const state = {
  show: false,
  newVersion: '',
}

const getters = {
  show: state => state.show,
  newVersion: state => state.newVersion,
}

const actions = {
  showNotification({ commit }, newVersion) {
    commit(types.SHOW_NOTIFICATION, { newVersion })
  },
}

const mutations = {
  [types.SHOW_NOTIFICATION](state, { newVersion }) {
    state.show = true
    state.newVersion = newVersion
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

